import { useAppDispatch, useAppSelector } from "../store";
import { assistantModalOpen, toggleAssistantModal } from "../store/slices/user";

const useAssistance = () => {
  const dispatch = useAppDispatch();
  const isAssistantModalOpen = useAppSelector(assistantModalOpen);

  const toggleAssistModal = () => dispatch(toggleAssistantModal());

  return {
    isAssistantModalOpen,
    toggleAssistModal
  };
};

export default useAssistance;
